import theme from '../themes/default'

export default {
  wrap: {
    background: '#614D4A',
    height: '80px',
    color: '#fff',
    'font-size': '28px',
    padding: '15px',
    'font-weight': 'bold',
    // 'position': 'absolute',
    // 'top': '45px',
    // 'width': '100%'
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/PageTitle.js